import { ArrowRight, Leaf, ShoppingBasket, Timer } from "lucide-react";
import { useNavigate } from "react-router-dom";
import "./GroceryPromoBanner.css";

const GroceryPromoBanner = () => {
    const navigate = useNavigate();

    const handleShopGroceries = () => {
        navigate("/Categories/Groceries");
    };

    return (
        <section className="grocery-promo">
            <div className="grocery-promo-container">
                <div className="grocery-promo-banner">
                    <img
                        src="/assets/images/banner/grocery-banner.jpg"
                        alt="Fresh groceries and everyday essentials"
                    />
                    <div className="grocery-promo-overlay" />
                    <div className="grocery-promo-content">
                        <span className="grocery-promo-kicker">SALAR GROCERIES</span>
                        <h2>
                            Fresh essentials,
                            <span>right when you need them.</span>
                        </h2>
                        <p>
                            Shop fresh produce, pantry favourites and everyday essentials selected for quality, convenience and value.
                        </p>
                        <button
                            type="button"
                            className="grocery-promo-action"
                            onClick={handleShopGroceries}
                        >
                            Shop Groceries
                            <ArrowRight size={16} strokeWidth={1.9} />
                        </button>
                    </div>
                    <div className="grocery-promo-features">
                        <div>
                            <span>
                                <Leaf size={14} strokeWidth={1.9} />
                            </span>
                            <div>
                                <strong>Fresh Picks</strong>
                                <small>Quality selected</small>
                            </div>
                        </div>
                        <div>
                            <span>
                                <ShoppingBasket size={14} strokeWidth={1.9} />
                            </span>
                            <div>
                                <strong>Daily Essentials</strong>
                                <small>Everything you need</small>
                            </div>
                        </div>
                        <div>
                            <span>
                                <Timer size={14} strokeWidth={1.9} />
                            </span>
                            <div>
                                <strong>Quick Delivery</strong>
                                <small>Delivered faster</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default GroceryPromoBanner;